import { getInputSpacingBySize } from '../input/styles';
import { DROPDOWN_COMPOSITE_LIST_MIN_WIDTH } from './constants';
import { DropdownCompositeSize } from './types';

/**
 * 옵션 항목은 목록 폭에서 좌우 padding 을 뺀 만큼 차지한다.
 * 목록 폭은 크기와 무관하게 같고 padding 만 크기별로 달라진다.
 */
export const getDropdownCompositeOptionWidth = (size: DropdownCompositeSize) =>
  DROPDOWN_COMPOSITE_LIST_MIN_WIDTH - getInputSpacingBySize(size) * 2;
